var UserProfile = (function () {
  var hash_name = "";
  var url = "https://www.webkey.hu";
  var userID = "";
  var companyID = "";
  var userVat = "";
  var abbreviation = "";

  var getURLProfile = function () {
    return url;
  };

  var getHashNameProfile = function () {
    return hash_name;
  };

  var getUserIDProfile = function () {
    return userID;
  };

  var getCompanyIDProfile = function () {
    return companyID;
  }

  var getUserVatProfile = function () {
    return userVat;
  }

var getAbbreviationProfile = function () {
  return abbreviation;
}

  var setHashNameProfile = function (name) {
    hash_name = name;
  };

  var setUserIDProfile = function (id) {
    userID = id;
  };

  var setCompanyIDProfile = function (id) {
    companyID = id;
  };

  var setUserVatProfile = function (vat) {
    userVat = vat;
  }

  var setAbbreviationProfile = function (abb) {
    abbreviation = abb;
  }


  return {
    getURL: getURLProfile,
    getHashName: getHashNameProfile,
    getUserID: getUserIDProfile,
    getCompanyID: getCompanyIDProfile,
    getUserVat: getUserVatProfile,
    getAbbreviation: getAbbreviationProfile,
    setHashName: setHashNameProfile,
    setUserID: setUserIDProfile,
    setCompanyID: setCompanyIDProfile,
    setUserVat: setUserVatProfile,
    setAbbreviation: setAbbreviationProfile
  }

})();

export default UserProfile;